import { render, staticRenderFns } from "./DailyStats.vue?vue&type=template&id=2360378c&scoped=true&"
import script from "./DailyStats.vue?vue&type=script&lang=js&"
export * from "./DailyStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360378c",
  null
  
)

export default component.exports